import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useViewport from 'src/hooks/useViewport'
import { selectCustomerId } from 'src/store/selectors/customerProfile'
import {
  selectListing,
  selectSimilarListings,
} from 'src/store/selectors/listings'
import { fetchListing, fetchSimilarListings } from 'src/actions/listing'
import { fetchFavoriteListings } from 'src/actions/favoriteListings'
import { setActiveTab } from 'src/actions/navigation'
import { OverlayMask } from 'src/Components'
import { selectScheduleTourShowModal } from 'src/store/slices/scheduleTour'
import { selectContactHomebotShowModal } from 'src/store/slices/contactHomebot'
import ScheduleTourWizard from './ScheduleTour/ScheduleTourWizard'
import ContactHomebotWizard from './ContactHomebot/ContactHomebotWizard'
import MobileDetails from './MobileListingDetails'
import { DesktopListingDetails } from './DesktopListingDetails'
import { PhotoPanel } from './PhotoPanel'
import { MapPanel } from './MapPanel'
import styles from './ListingDetails.module.scss'
import { BotHeadSpinWithMessage } from 'src/Components'
import { FormattedMessage } from 'react-intl'
import { TAB_NAMES } from 'src/constants/navigation'
import { RouteComponentProps } from 'react-router'

interface ListingDetailsMatchParams {
  listingId: string
}

export const ListingDetails = ({
  match,
}: RouteComponentProps<ListingDetailsMatchParams>) => {
  const customerId = useSelector(selectCustomerId)
  const { listingId } = match.params
  const dispatch = useDispatch()
  const { isMediumOrAbove } = useViewport()
  const listing = useSelector(selectListing)
  const similarListings = useSelector(selectSimilarListings)
  const showModal = useSelector(selectScheduleTourShowModal)
  const showContactHomebotModal = useSelector(selectContactHomebotShowModal)

  useEffect(() => {
    dispatch(setActiveTab(TAB_NAMES.LISTING))
  }, [dispatch])

  useEffect(() => {
    if (customerId) {
      dispatch(fetchListing(customerId, listingId))
      dispatch(fetchSimilarListings(listingId, false))
      dispatch(fetchFavoriteListings(customerId))
    }
  }, [dispatch, customerId, listingId])

  const getListingDetailsOrLoading = () => {
    if (listing.loading) {
      return (
        <BotHeadSpinWithMessage className={styles.loadingContainer}>
          <FormattedMessage
            id='BotHeadSpinWithMessage.ListingDetails'
            defaultMessage='Loading home details...'
          />
        </BotHeadSpinWithMessage>
      )
    }
    if (!isMediumOrAbove) {
      return (
        <MobileDetails listing={listing} similarListings={similarListings} />
      )
    }
    if (isMediumOrAbove) {
      return (
        <DesktopListingDetails
          listing={listing}
          similarListings={similarListings}
        />
      )
    }
    return null
  }
  return (
    <>
      <PhotoPanel listing={listing} />
      <MapPanel listing={listing} />
      <OverlayMask isExact>
        <div className={styles.container}>{getListingDetailsOrLoading()}</div>
      </OverlayMask>
      {showModal && <ScheduleTourWizard />}
      {showContactHomebotModal && <ContactHomebotWizard />}
    </>
  )
}
